/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/mobileinstallcheck";
const mobileInstallCheckService = {
    getinstallcheck(assetId) {
        return http.get(`${controller}/${assetId}?cycledEquipment=true&isWeb=true`);
    }
};
export default mobileInstallCheckService;
